/* eslint-disable no-unused-vars */
import React, {useEffect} from "react";
import {useState} from "react";
import {Container, Backdrop} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {TextDecrypt} from "../content/TextDecrypt";
import Modal from '@mui/material/Modal';
import './Works.css';
import Fade from "@material-ui/core/Fade";
// Import ../../assets/recentprojects/

const useStyles = makeStyles((theme) => ({
    main: {
        maxWidth: '100vw',
        marginTop: '3em',
        marginBottom: "auto",
    },
}));

const style = {
    position: 'absolute',
    zIndex: 100,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: "100%",
    // height: "100%",
    // boxShadow: 24,
    // p: 4,
};
const useStyless = makeStyles((theme) => ({
    gridList: {
        flexWrap: "nowrap",
        transform: "translateZ(0)"
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            backgroundcolor: "red"
        }
    },
    img: {
        outline: "none"
    }
}));

export const Works = () => {
    const classes = useStyles();
    const [fullText, setFullText] = useState(false);
    const [nnew, setNew] = useState("");
    const [open, setOpen] = useState(false)
    const [image, setImage] = useState()
    const [pos, setPos] = useState(95);

    const [projects, setProjects] = useState([
        {
            id: 1,
            title: 'React',
            description: `I developed a CRUD application using ReactJs and NextJs, with Material UI, AntD, and Bootstrap.
             The application integrates with a REST API using Axios and features state management with Redux,
              Redux Thunk, Redux Persist, and Redux Saga. It also includes GraphQL for efficient data querying.
               This project demonstrates my skills in modern web development and user experience design.`,
            alter: 'React Portfolio',
            image: `https://i.postimg.cc/7ZHbYyCs/react-portfolio.png`, /*react-portfolio.png*/
        },
        {
            id: 2,
            title: 'React Project',
            description: `This project was built using React js with Material UI, Axios, jspdf, qrcode, and sass.
             It also includes additional functionalities and features. On the backend, it utilizes express js, fs,jsonwebtoken, multer, and passport.
               This project showcases my skills in modern web development and my ability to incorporate various technologies and frameworks to
                create a functional and engaging application.`,
            alter: 'VeriTru Project',
            image: `https://i.postimg.cc/BbjczK3F/veritru.png`,  /*veritru.png*/
        },
        {
            id: 3,
            title: 'Design',
            description: `This website was developed using ReactJS, with the front-end designed using apexcharts, 
            Material UI, chart.js, react-apexcharts, and react-chartjs-2.
             This project showcases my skills in ReactJS and my ability to create visually appealing and interactive user experiences
              with modern web development technologies.`,
            alter: 'LoFo Project',
            image: `https://i.postimg.cc/GpSjxKwR/lofo.png`,   /*lofo.png*/
        },
        {
            id: 4,
            title: 'Charts Project',
            description: `A library of various chart types, including bar, line, and pie charts.
             Developed using apexcharts, chart.js, and other modern technologies.
             Includes a world map feature using react-jvectormap.
             Demonstrates expertise in web development and user-friendly design.`,
            alter: 'Startup Project',
            image: `https://i.postimg.cc/kGCRQR49/startup.png`,  /*startup.png*/
        },
        {
            id: 5,
            title: 'ToDo List',
            description: `I have developed a dynamic and feature-rich ToDo list application using redux-persist,
             along with a variety of other tools and technologies to enable advanced functionality and usability.
              This project showcases my skills in web development and my ability to create intuitive and user-friendly
               applications that help individuals and teams stay organized and on track.`,
            alter: 'Startup Project',
            image: `https://i.postimg.cc/tCS7TMh9/lacalle.png`,  /*lacalle.png*/
        },
    ]);

    const classess = useStyless();

    const handleFullScreen = (image) => {
        document.documentElement.requestFullscreen();
        setImage(image)
        setOpen(!open)
    }
    const handleExitFullScreen = () => {
        document.exitFullscreen();
        setImage()
        setOpen(!open)
        setPos(95)
    }


    const onScroll = (e) => {
        const delta = e.deltaY * -0.01;
        if (delta === -1.6666665649414063 && pos < 135) setPos(pos + 4);
        else if (delta === 1.6666665649414063 && pos > 10) setPos(pos - 4);
    };

    const body = (<>
            <Fade in={open} timeout={800} className={classes.img} onWheelCapture={(e) => onScroll(e)}>
                <img
                    src={image}
                    alt="asd"
                    draggable
                    style={{
                        maxHeight: `${pos}%`,
                        maxWidth: `${pos}%`,
                        transformOrigin: "0 0",
                    }}
                />
            </Fade>
        </>
    )


    return (<>
        <section id="works">
            <Container component="main" className={classes.main} maxWidth="md">
                {projects.map((project) => {
                    return (
                        <div className="project" key={project.id}>
                            <div className="__img_wrapper">
                                <img src={project.image} alt={project.alter} className="imgWork"
                                     onClick={() => handleFullScreen(project.image)}/>
                            </div>
                            <div className="__content_wrapper" style={{backdropFilter: "blur(10px)"}}>
                                <h3 className="title">
                                    <TextDecrypt text={project.title}/>
                                </h3>
                                <p className="description">
                                    {project?.description?.length > 100 ? fullText && project?.id === nnew.id ? nnew?.description : project?.description?.slice(0, 100) : project?.description}

                                    {project?.description?.length > 100 &&
                                    <span className="show"
                                          onClick={() => {
                                              setFullText(!fullText)
                                              setNew(project)
                                          }}>{project?.description?.length > 100 && fullText && project?.id === nnew.id ? ' See Less' : ' See More.....'}</span>}
                                </p>
                            </div>
                        </div>
                    )
                })}
            </Container>
        </section>
        <Modal
            className={classess.modal}
            open={open}
            onClose={handleExitFullScreen}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 800
            }}
        >
            {body}
        </Modal>
    </>);
};
